import { render, staticRenderFns } from "./MenuDrawer.vue?vue&type=template&id=5b95f1b7&lang=pug"
import script from "./MenuDrawer.vue?vue&type=script&lang=coffee"
export * from "./MenuDrawer.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports